import jwt from "../../http/requests/auth/jwt/index.js";
import router from "@/router";
import acl from "@/acl/acl";
import api from "@/api/index";

export default {
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.phone, payload.password)
        .then(response => {
          // If there's user data in response
          if (response.data && response.status == 200) {
            let accessToken = response.data.access,
              refreshToken = response.data.refresh;

            // Set accessToken
            localStorage.setItem("accessToken", accessToken);
            localStorage.setItem("refreshToken", refreshToken);

            let userRole = "";
            if (response.data.is_staff) {
              userRole = "admin";
            } else if (response.data.is_security) {
              userRole = "security";
            } else if (response.data.is_cafe_personal) {
              userRole = "cafe";
            } else if (response.data.is_market_personal) {
              userRole = "market";
            }

            let userData = {
              uid: jwt._parseTokenData(accessToken).user_id,
              displayName: response.data.phone,
              about: "",
              photoURL: require("@/assets/images/avatar.jpg"),
              status: "online",
              userRole: userRole
            };

            let fcmToken = localStorage.getItem("fcm_token");
            if (fcmToken !== null) {
              api.users.updateFCMTokenUser(fcmToken).data;
            }

            // Update user details
            commit("UPDATE_USER_INFO", userData, { root: true });

            //Сохраняем время
            localStorage.setItem("exp", jwt._parseTokenData(accessToken).exp);

            // Navigate User to homepage
            if (userData.userRole == "security") {
              router.push({ name: "passes" });
            } else if (userData.userRole == "admin") {
              router.push(router.currentRoute.query.to || "/");
            }

            resolve(response);
          } else {
            reject({
              message:
                "Неправильные данные для входа. Пожалуйста, попробуйте снова."
            });
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  logout({ commit }, payload) {
    let fcm = localStorage.getItem("fcm_token");
    localStorage.clear();

    if (fcm !== null && fcm !== "null") localStorage.setItem("fcm_token", fcm);

    let userData = {
      uid: "",
      displayName: "",
      about: "",
      photoURL: "",
      status: "offline",
      userRole: "guest"
    };

    // Update user details
    commit("UPDATE_USER_INFO", userData, { root: true });

    //Изменение userRole в ACL, чтобы был редирект
    this._vm.$acl.change(userData.userRole);

    // Navigate User to page login
    router.push({ name: "page-login" });

    this._vm.$vs.loading.close();
  }
};
